import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { UserLoginDtlService } from 'src/app/service/user-login-dtl.service';
import { pytCustTblOptions, PytCustTblService } from '../pyt-cust-tbl.service';
import * as XLSX from 'xlsx';
import {
  _DOWNLOAD_TYPE,
  DOWNLOAD_TYPE,
  ReportConfig,
} from '../pytCustTbl.helper';
import {
  ConfirmationModalConfig,
  ConfirmationModalService,
} from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import { ApiService } from '@core/auth/auth.service';
// import { DOWNLOAD_TYPE } from '@core/common/common-config';
@Component({
  selector: 'app-pyt-tbl-top-box',
  templateUrl: './pyt-tbl-top-box.component.html',
  styleUrls: ['./pyt-tbl-top-box.component.scss'],
})
export class PytTblTopBoxComponent implements OnInit {
  @Input() tableOptions!: pytCustTblOptions;

  @Input() rotateIt: boolean = false;
  @Input() searchTypeWidth: string = '400px';
  @Output() reloadTbl = new EventEmitter<void>();

  @Input() isReportCanDownload: boolean = false;
  @Output() downloadReport = new EventEmitter<void>();
  @Output() addBtn: EventEmitter<any> = new EventEmitter<any>();

  download_reports: boolean = true;
  downloadFileType!: _DOWNLOAD_TYPE[];
  config = {
    value: true,
    name: 'abc',
    disabled: false,
    height: 35,
    width: 80,
    margin: 3,
    fontSize: 10,
    speed: 300,
    color: {
      checked: '#3D9C3C',
      unchecked: '#00659E',
    },
    switchColor: {
      checked: '#101F33',
      unchecked: '#101F33',
    },
    labels: {
      unchecked: 'kyc',
      checked: 'Merchant',
    },
    fontColor: {
      checked: '#fafafa',
      unchecked: '#ffffff',
    },
  };
  checked!: boolean;
  downloadReportsConfig: ReportConfig | null;
  // download_reports = this._UserLoginDtlService.getLoginDtlKeyValue(
  //   'permission.download_reports'
  // );
  constructor(
    public _PytCustTblService: PytCustTblService,
    // private _UserLoginDtlService: UserLoginDtlService,
    private _ApiService: ApiService,
    private _ConfirmationModalService: ConfirmationModalService
  ) { }

  ngOnInit(): void {
    this.downloadReportsConfig = this.tableOptions.config.downloadReports;

    this.downloadFileType =
      this.downloadReportsConfig && 'fileTypes' in this.downloadReportsConfig
        ? (this.downloadReportsConfig?.fileTypes as _DOWNLOAD_TYPE[])
        : DOWNLOAD_TYPE;
  }

  onAddButton() {
    this.addBtn.emit(true);
  }
  download1() {
    let formdata = this.tableOptions.config.downloadReports?.formData();
    this._ApiService.post(this.tableOptions.config.downloadReports?.url, formdata)
      .subscribe((res: any) => {
        if (res.statuscode == 200) {
          const fileName =
            this.tableOptions.config.downloadReports?.fileName + '.csv';
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(res['data']);
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            wb,
            ws
            // this.tableOptions.config.downloadReports?.fileName
          );
          XLSX.writeFile(wb, fileName);
        } else {
          // Swal.fire({
          //   icon: 'error',
          //   title: res.message,
          // });
        }
      });
  }

  download(filetype: _DOWNLOAD_TYPE) {
    let formData = this.downloadReportsConfig?.formData();
    let fileName = this.downloadReportsConfig?.fileName;
    let name = typeof fileName === 'function' ? fileName() : fileName;
    // formData.set('length', 'All');
    this._ApiService.post(
      this.downloadReportsConfig?.url,
      formData,
      this.downloadReportsConfig?.baseUrl
    )
      .subscribe((res: any) => {
        let fileName: any = name + (filetype.value ?? '.xlsx');
        if (res.statuscode == 200 || res.code == 200) {
          let mainData: any = [];
          let data: any[] = [];
          data = res.data;
          // if (res.data) {
          // } else {
          //   data = res.data
          // }
          if (!res.header) {
            let header: any[] = [];
            for (const key in data[0]) {
              const element = data[0][key];
              header.push({
                name: key,
                value: key,
                is_show: 1,
                issort: 0,
              });
            }
            res.header = header;
          }
          (data as []).forEach((e: any) => {
            let obj: any = {};

            (res.header as []).forEach((l: any) => {
              if (l.is_show) {
                obj[l.name] = e[l.name];
              }
            });
            mainData.push(obj);
          });

          (mainData as []).forEach((e: any, i: number) => {
            for (const key in e) {
              // const eType: any = e[key];
              // const nameType: any = parseFloat(eType);
              // const dType: any = Date.parse(eType);
              // if (key === 'time' || key === 'account_no') { } else
              //   if (isNaN(eType) && !isNaN(dType)) {
              //   } else if (!isNaN(nameType)) {
              //     e[key] = nameType;
              //   }
              if (key === 'slr' && !e[key]) {
                e[key] = i + 1;
              }
              // const etype: any = e[key];
              // const etype: any = e[key];
              // const nmype: any = parseFloat(etype);
              // const dtype: any = Date.parse(etype);
              // if (key === 'time' || key === 'account_no') { } else
              //   if (isNaN(etype) && !isNaN(dtype)) {
              //   } else if (!isNaN(nmype)) {
              //     e[key] = nmype;
              //   }
            }
          });
          this._PytCustTblService.exportFile(
            fileName,
            filetype.value,
            mainData
          );
          // const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(mainData);
          // const wb: XLSX.WorkBook = XLSX.utils.book_new();
          // if (filetype.value == '.csv') {
          // XLSX.utils.sheet_to_csv(ws, { FS: ":", RS: "|" })
          // }
          // XLSX.utils.book_append_sheet(wb, ws, name);
          // XLSX.writeFile(wb, fileName);
        } else {
          // Swal.fire({
          //   icon: 'error',
          //   title: res.message,
          // });
          const customConfig: ConfirmationModalConfig = {
            data: {
              icon: 'error',
              msg: res.message,
              // btnConfirm: 'Okay',
              btnClose: 'Okay',
              allowOutsideClick: false,
              allowEscapeKey: false,
            },
          };
          this._ConfirmationModalService
            .init(ConfirmationComponent, customConfig)
            .subscribe((events: any) => {
              events.initRef.close();
            });
        }
      });
  }

  exportFile(name: string, type: string, data: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    if (type == '.csv') {
      XLSX.utils.sheet_to_csv(ws, { FS: ':', RS: '|' });
    } else if (type == '.txt') {
      XLSX.utils.sheet_to_txt(ws);
    }

    XLSX.utils.book_append_sheet(wb, ws, name);
    XLSX.writeFile(wb, type);
  }
}
